import { useBreakpointValue } from '@chakra-ui/react'
import { ImageBox } from 'ui'
import { logo } from '#/src/custom/constants/layout'
import { useAppConfigContext } from '#/src/appConfig'

/** Header logo. Shared by the shop layout and the maintenance page. */
export const TopNavLogo = () => {
  const appConfig = useAppConfigContext()
  const logoHeaderSrc = useBreakpointValue({ base: logo.header.mobile, lg: logo.header.desktop })

  return (
    <ImageBox
      h={{
        base: '27px',
        lg: '35px'
      }}
      imageProps={{
        title: appConfig.site.title,
        alt: appConfig.site.title,
        src: logoHeaderSrc,
        style: {
          objectFit: 'contain'
        },
        quality: 100,
        priority: true,
        sizes: '10em'
      }}
      w={{
        base: '214px',
        lg: '280px'
      }}
    />
  )
}
